import { mapEntityProperties } from '@/utils/mapEntityProperties'
import { ReminderSettingEntity } from '../../domain/entities/ReminderSettingEntity'
import type { ReminderSettingAdminDto } from '@/backend/market'
export class ReminderSettingModel extends ReminderSettingEntity {
  constructor(dataDto: ReminderSettingAdminDto) {
    super()
    mapEntityProperties<ReminderSettingEntity>(this, dataDto)
  }
}
